module.exports = __webpack_public_path__ + "img/revelado.974d1048.png";